// The white toolbar button: 36 px high, a gray ring, gray-900 text. The Components that sit in one row of a card header
// use it (CheckboxMenu variant 'button', FormButton variant 'toolbar'), so that the row has one height and one look.
// The frame and the colours are apart: a disabled button gets other colours, never two background classes.
const FRAME = 'inline-flex h-9 items-center gap-x-2 whitespace-nowrap rounded-md px-3 text-sm font-medium shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600';

export const TOOLBAR_BUTTON = `${FRAME} bg-white text-gray-900 hover:bg-gray-50`;

// A disabled toolbar button: gray text on a gray ground, no hover.
export const TOOLBAR_BUTTON_DISABLED = `${FRAME} cursor-not-allowed bg-gray-50 text-gray-400`;
